<template>
  <b-row>
    <b-col cols="12" lg="4">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.excmagreements.list.filters.company') }}:</label>
<!--        <input v-model.lazy="filters.company" v-debounce="delay" class="form-control" type="text" placeholder="">-->
        <fg-input>
          <el-select
            id="exsbbatchnumber_invoiceType"
            class="select-default"
            :placeholder="$t('views.excmagreements.form.company')"
            filterable
            v-model="filters.company">
            <el-option v-for="option in companyOptions"
                       class="select-default"
                       :value="option['@id']"
                       :label="option.firmname1"
                       :key="option['@id']">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </b-col>
    <b-col cols="12" lg="4">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.excmagreements.list.filters.agreementNumber') }}:</label>
        <input v-model.lazy="filters.agreementNumber" v-debounce="delay" class="form-control" type="text" placeholder="">
      </div>
    </b-col>
    <b-col cols="12" lg="4">
      <div class="form-group">
        <label class="form-control-label">{{ $t('views.excmagreements.list.filters.state') }}:</label>
        <b-form-group>
          <b-form-radio-group
            v-model="filters.state"
            :options="radioOptions"
            buttons
            button-variant="outline-primary"
            name="radios-btn-default"
          ></b-form-radio-group>
        </b-form-group>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import debounce from 'v-debounce'

export default {
  name: 'AgreementsFiltering',

  props: {
    getPage: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      radioOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      delay: 500,
      filters: {
        company: null,
        state: 1,
        agreementNumber: ''
      },
      companyOptions: [],
      loading: false
    }
  },

  directives: {
    debounce
  },

  created () {
    this.getCompanies()
  },

  watch: {
    'filters.company': function () {
      this.filter()
    },
    'filters.state': function () {
      this.filter()
    },
    'filters.agreementNumber': function () {
      this.filter()
    }
  },
  methods: {
    filter () {
      let url = 'e_x_c_m_agreements?_page=1'
      url += '&state=' + this.filters.state
      if (this.filters.company) {
        url += '&company=' + this.filters.company
      }
      if (this.filters.agreementNumber) {
        url += '&agreementNumber=' + this.filters.agreementNumber
      }
      this.getPage(url)
    },
    getCompanies () {
      this.companyOptions = []
      this.$http.get('api/user_datas', {
        params: {
          isCompany: 1,
          pagination: false,
          state: 1
        }
      })
        .then(response => {
          this.companyOptions = response.data['hydra:member']
          this.companyOptions.unshift({
            '@id': null,
            firmname1: this.$t('global.allOptions')
          })
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    remoteMethod () {
      // console.log()
    }
  }
}
</script>
